<script lang="ts">
  import { AccordionItem, Col,Accordion, Image, CardBody } from "sveltestrap";
  import { href } from "../../../../utils/Constant/Constant";
  import Link from "svelte-link";
  import data from "../../../../Data/Users/Users.json"
  let imgPath:string = "/assets/images/user"

</script>
{#each data.usersdata as userdata}
    <Col xl="12" lg="6" md="12" sm="6">
        <Accordion>
            <AccordionItem active header={userdata.header}>
                <CardBody class="social-list filter-cards-view">
                    {#each userdata.userfollwersdata as userItem}
                        <div class="media">
                            <Image fluid class="img-50 m-r-20 rounded-circle" alt="" src="{imgPath}/{userItem.img}" />
                            <div class="media-body">
                                <span class="d-block">{userItem.name}</span>
                                <Link href={href}>{userItem.requste}</Link>
                            </div>
                        </div>
                    {/each}
                </CardBody>
            </AccordionItem>
        </Accordion>
    </Col>
{/each}